import {
  Box,
  TextField,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import MyProSidebar from "../../../COMPONENTS/sidebar/Sidebar";
import Topbar from "../../../COMPONENTS/navbar/Topbar";
import "./assessReport.css";
import Header from "../../../COMPONENTS/header/Header";
import { Link } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import AuthContext from "../../../CONTEXT/AuthProvider";
import DatePicker from "react-datepicker";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import SearchOffOutlinedIcon from "@mui/icons-material/SearchOffOutlined";
import "react-datepicker/dist/react-datepicker.css";
import StatBox from "../../../COMPONENTS/StatBox";

function AssessReport() {
  const { auth } = useContext(AuthContext);
  const accessToken = auth.accessToken;
  const subscribername = auth.subscriberName;
  const staff = auth.staff;

  const [subscribersList, setSubscribersList] = useState([]);
  const [subscriber, setSubscriber] = useState();

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [searchResponse, setSearchResponse] = useState([]);
  const [countSearchRespnse, setCountSearchResponse] = useState();
  const [status, setStatus] = useState("");

  useEffect(() => {
    axios
      .get("/api/subscribers", {
        headers: {
          Authorization: "Bearer " + accessToken,
        },
      })
      .then((response) => {
        setSubscribersList(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  const currentDate = new Date();

  const years = [];
  for (let i = 2000; i <= currentDate.getFullYear(); i++) {
    years.push(i);
  }

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const formatDate = (date) => {
    if (!date) return ""; // Handle null or undefined date
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Note: Month is zero-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const getMaxEndDate = () => {
    const today = new Date();
    const lastDateOfMonth = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    return lastDateOfMonth;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formattedStartDate = formatDate(startDate);
    const formattedEndDate = formatDate(endDate);

    const subscriberName = subscriber || subscribername;

    const data = {
      status,
      subscriberName,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    };

    if (staff === "Yes") {
      axios
        .get(
          "/api/assess-searches",
          { params: data },
          {
            headers: {
              Authorization: "Bearer " + accessToken,
            },
          }
        )
        .then((response) => {
          const dataResponse = response.data.map((subscribers, index) => ({
            ...subscribers,
            rowNumber: index + 1,
          }));
          setCountSearchResponse(dataResponse.length);
          setSearchResponse(dataResponse);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      axios
        .get(
          "/api/assess-searches",
          { params: data },
          {
            headers: {
              Authorization: "Bearer " + accessToken,
            },
          }
        )
        .then((response) => {
          const dataResponse = response.data
            .filter(
              (subscribers) => subscribers["subscriber_name"] === subscribername
            )
            .map((subscribers, index) => ({
              ...subscribers,
              rowNumber: index + 1,
            }));
          setCountSearchResponse(dataResponse.length);
          setSearchResponse(dataResponse);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const columns = [
    {
      field: "rowNumber",
      headerName: "#",
      flex: 0.2,
    },
    {
      field: "phone_number_identifier",
      headerName: "Phone Number Identifier",
      flex: 1.3,
    },
    {
      field: "name_identifier",
      headerName: "Name Identifier",
      flex: 1.3,
    },
    {
      field: "processed",
      headerName: "Processed",
      flex: 1.3,
    },
    {
      field: "username",
      headerName: "Username",
      flex: 0.7,
    },
    {
      field: "subscriber_name",
      headerName: "Subscriber Name",
      flex: 1.5,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.8,
      renderCell: (params) => {
        const status = params.value;
        const cellClassName = status === "SUCCESS" ? "green-bg" : "red-bg";
        return <div className={cellClassName}>{status}</div>;
      },
    },
  ];
  return (
    <div className="app">
      <MyProSidebar />
      <main className="content">
        <Topbar />
        <Box m="8px">
          <Box m="8px">
            <Header
              title="SEARCH REPORT"
              subtitle="Search and assess subscribers' search report"
            />
          </Box>
          <div className="search-heading">
            <div className="count">
              <Box
                display="grid"
                gridTemplateColumns="repeat(12, 1fr)"
                gridAutoRows="140px"
                gap="20px"
              >
                <Box
                  gridColumn="span 20"
                  backgroundColor="#f2f0f0"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  {status === "SUCCESS" ? (
                    <StatBox
                      title={countSearchRespnse || 0}
                      subtitle="Successful Searches"
                      icon={
                        <SearchOutlinedIcon
                          sx={{ color: "#70d8bd", fontSize: "26px" }}
                        />
                      }
                    />
                  ) : (
                    <StatBox
                      title={countSearchRespnse || 0}
                      subtitle="Failed Searches"
                      icon={
                        <SearchOffOutlinedIcon
                          sx={{ color: "#70d8bd", fontSize: "26px" }}
                        />
                      }
                    />
                  )}
                </Box>
              </Box>
            </div>
            <div className="report-heading">
              <div>
                <p className="head-title">Search by:</p>
              </div>
              <div className="datepicker">
                <div>
                  <DatePicker
                    className="searchDate"
                    placeholderText="Start Date"
                    renderCustomHeader={({
                      date,
                      changeYear,
                      changeMonth,
                      decreaseMonth,
                      increaseMonth,
                      prevMonthButtonDisabled,
                      nextMonthButtonDisabled,
                    }) => (
                      <div
                        style={{
                          margin: 0,
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          onClick={decreaseMonth}
                          disabled={prevMonthButtonDisabled}
                        >
                          {"<"}
                        </button>
                        <select
                          value={date.getFullYear()} // Use getFullYear() to get the year
                          onChange={({ target: { value } }) =>
                            changeYear(parseInt(value))
                          }
                        >
                          {years.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>

                        <select
                          value={months[date.getMonth()]} // Use getMonth() to get the month
                          onChange={({ target: { value } }) =>
                            changeMonth(months.indexOf(value))
                          }
                        >
                          {months.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>

                        <button
                          onClick={increaseMonth}
                          disabled={nextMonthButtonDisabled}
                        >
                          {">"}
                        </button>
                      </div>
                    )}
                    selected={startDate}
                    onChange={handleStartDateChange}
                    maxDate={getMaxEndDate()}
                    showMonthDropdown
                    showYearDropdown
                    dateFormat="dd-MM-yyyy"
                    dropdownMode="select"
                  />
                </div>
                <div>
                  <DatePicker
                    className="searchDate"
                    placeholderText="End Date"
                    renderCustomHeader={({
                      date,
                      changeYear,
                      changeMonth,
                      decreaseMonth,
                      increaseMonth,
                      prevMonthButtonDisabled,
                      nextMonthButtonDisabled,
                    }) => (
                      <div
                        style={{
                          margin: 0,
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          onClick={decreaseMonth}
                          disabled={prevMonthButtonDisabled}
                        >
                          {"<"}
                        </button>
                        <select
                          value={date.getFullYear()} // Use getFullYear() to get the year
                          onChange={({ target: { value } }) =>
                            changeYear(parseInt(value))
                          }
                        >
                          {years.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>

                        <select
                          value={months[date.getMonth()]} // Use getMonth() to get the month
                          onChange={({ target: { value } }) =>
                            changeMonth(months.indexOf(value))
                          }
                        >
                          {months.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>

                        <button
                          onClick={increaseMonth}
                          disabled={nextMonthButtonDisabled}
                        >
                          {">"}
                        </button>
                      </div>
                    )}
                    selected={endDate}
                    onChange={handleEndDateChange}
                    maxDate={getMaxEndDate()}
                    showMonthDropdown
                    showYearDropdown
                    minDate={startDate}
                    dateFormat="dd-MM-yyyy"
                    dropdownMode="select"
                  />
                </div>
                <div>
                  <FormControl fullWidth variant="filled">
                    <InputLabel id="status-label">Select Status</InputLabel>
                    <Select
                      labelId="status-label"
                      name="status"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                      className="statusBox"
                    >
                      <MenuItem value=""></MenuItem>
                      <MenuItem value="SUCCESS">Success</MenuItem>
                      <MenuItem value="FAIL">Fail</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                {staff === "Yes" && (
                  <div>
                  <FormControl
                    fullWidth
                    variant="filled"
                    sx={{ gridColumn: "span 2" }}
                  >
                    <Autocomplete
                      id="subscriber-select"
                      className="statusBox"
                      options={subscribersList}
                      getOptionLabel={(option) => option.subscriber_name}
                      value={
                        subscribersList.find(
                          (sub) => sub.subscriber_name === subscriber
                        ) || null
                      }
                      onChange={(e, newValue) =>
                        setSubscriber(newValue ? newValue.subscriber_name : "")
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="subscriber"
                          label="Subscriber"
                        />
                      )}
                    />
                  </FormControl>
                </div>
                )}
                

                <div>
                  <Link className="link" onClick={handleSubmit}>
                    Search
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <Box m="8px">
            <Box
              m="40px 0 0 0"
              height="100vh"
              sx={{
                "& .MuiDataGrid-root": {
                  border: "none",
                },
                "& .MuiDataGrid-cell": {
                  borderBottom: "none",
                },
                "& .name-column--cell": {
                  color: "#2e7c67",
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#bbbbbb",
                  borderBottom: "none",
                },
                "& .MuiDataGrid-virtualScroller": {
                  backgroundColor: "#f2f0f0",
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: "none",
                  backgroundColor: "#a4a9fc",
                },
                "& .MuiCheckbox-root": {
                  color: `${"#1e5245"} !important`,
                },
                "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                  color: `${"#525252"} !important`,
                },
              }}
            >
              <DataGrid
                rows={searchResponse}
                columns={columns}
                components={{ Toolbar: GridToolbar }}
              />
            </Box>
          </Box>
        </Box>
      </main>
    </div>
  );
}

export default AssessReport;
